/**
 * tokenErrorConstants
 *
 */
const constantPrefix = 'TOKEN_ERROR';
export default {
  INCREMENT: `${constantPrefix}_INCREMENT`,
  RESET: `${constantPrefix}_RESET`,
  RETRY_ON_SUCCESS: `${constantPrefix}_RETRY_ON_SUCCESS`
};